module.exports = __webpack_public_path__ + "static/media/kursreacta.96c36fa2.png";